import { gql } from 'apollo-angular';

const UPDATE_USER_NOTIFICATIONS = gql`
  mutation updateNotification(
    $userId: Long!
    $notifications: [NotificationRequest]!
  ) {
    updateNotification(
      updateNotificationRequest: {
        userId: $userId
        notifications: $notifications
      }
    ) {
      id
      subscriptions {
        name
        subscribed
      }
    }
  }
`;

export default UPDATE_USER_NOTIFICATIONS;
